import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import CopyAllIcon from "@mui/icons-material/CopyAll";
import styles from "./styles.module.css";
import { useState, useEffect, useCallback } from "react";
import SnackBar from "../../SnackBar";

const ModalNovaVersaoProjeto = ({
  open,
  onClose,
  onCreate,
  loading = false,
  tipoProjeto = "PIS-COFINS", // Tipo de projeto
  idProjeto = null, // ID do projeto
  dadosProjeto = null, // Dados do projeto para obter razão social
  versoesExistentes = [], // Lista de versões existentes para calcular próximo número
}) => {
  const [nomeVersao, setNomeVersao] = useState("");
  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });

  // Função para gerar nome da versão automaticamente
  const gerarNomeVersao = useCallback(() => {
    if (!dadosProjeto) return "";

    // Obter primeiro nome da razão social
    const primeiroNome = dadosProjeto.razaoSocial?.split(" ")[0] || "Projeto";

    // Data atual
    const dataAtual = new Date().toLocaleDateString("pt-BR");

    // Calcular próximo número da versão
    // Filtrar versões que não são "Original"
    const versoesValidas = versoesExistentes.filter(
      (versao) =>
        versao.idProjetoVersao !== 0 && versao.idProjetoVersao !== null
    );
    const proximoNumero = versoesValidas.length + 1;

    // Gerar nome: Projeto + Primeiro nome + Data + Número da versão
    // Ex.: "Projeto ACME 08/10/2025 2"
    return `Projeto ${primeiroNome} ${dataAtual} ${proximoNumero}`;
  }, [dadosProjeto, versoesExistentes]);

  // Atualizar nome da versão quando modal abrir
  useEffect(() => {
    if (open && dadosProjeto) {
      const nomeGerado = gerarNomeVersao();
      setNomeVersao(nomeGerado);
    } else if (open && !dadosProjeto) {
      setNomeVersao("");
    }
  }, [open, dadosProjeto, gerarNomeVersao]);

  // Reset quando modal fecha
  useEffect(() => {
    if (!open) {
      setNomeVersao("");
      setObjSnackBar({ type: "", msg: "" });
    }
  }, [open]);

  const handleClose = () => {
    setNomeVersao("");
    setObjSnackBar({ type: "", msg: "" });
    onClose();
  };

  const handleConfirm = async () => {
    // Chamar função de criação
    try {
      await onCreate(nomeVersao.trim());
      handleClose();
    } catch (error) {
      setObjSnackBar({
        type: "error",
        msg: "Erro ao criar versão.",
      });
    }
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>
          <div className={styles.title}>
            <CopyAllIcon sx={{ marginRight: ".5rem" }} />
            Nova Versão do Projeto
          </div>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <TextField
            label="Nome da Versão"
            variant="outlined"
            fullWidth
            value={nomeVersao}
            InputProps={{
              readOnly: true,
            }}
            placeholder="Gerando nome da versão..."
          />
          <DialogActions className={styles.containerBtn}>
            <Button
              onClick={handleClose}
              variant="contained"
              className={styles.btnCancelar}
              disabled={loading}
            >
              Cancelar
            </Button>
            <Button
              onClick={handleConfirm}
              variant="contained"
              className={styles.btnSalvar}
              disabled={loading}
            >
              {loading ? "Criando..." : "Criar Versão"}
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={setObjSnackBar} />
    </>
  );
};

export default ModalNovaVersaoProjeto;
